
import { PropertyType } from "../types/propertyTypes";

const mockProperties: PropertyType[] = [
  {
    id: 1, // Changed from string to number
    title: "Modern Office Space in Colombo 3",
    price: 250000000,
    priceType: "fixed",
    type: "Office",
    category: "sale",
    address: {
      street: "42 Marine Drive",
      city: "Colombo",
      state: "Western Province",
      zip: "00300",
    },
    details: {
      area: 2500,
      areaUnit: "SF",
      bedrooms: 0,
      bathrooms: 2,
      parkings: 4,
      yearBuilt: 2018,
      propertyType: "Office",
      status: "Available",
      description:
        "Premium office space with panoramic sea views, modern facilities, and excellent connectivity. Perfect for corporate headquarters or regional office.",
      amenities: [ // Added amenities array
        "24/7 Security",
        "Backup Generator",
        "Central AC",
        "Fiber Internet",
        "Meeting Rooms",
        "Rooftop Garden",
      ],
    },
    features: [
      "24/7 Security",
      "Backup Generator",
      "Central AC",
      "Fiber Internet",
      "Meeting Rooms",
      "Rooftop Garden",
    ],
    images: [
      "https://images.unsplash.com/photo-1497366811353-6870744d04b2",
      "https://images.unsplash.com/photo-1497366754035-f200968a6e72",
      "https://images.unsplash.com/photo-1497366216548-37526070297c",
    ],
    agent: {
      name: "Samantha Perera",
      phone: "(+94) 77-123-4567",
      email: "samantha@commercialproperty.lk",
      company: "Commercial Property LK",
    },
    createdAt: "2023-01-15T08:30:00Z",
    isFeatured: true,
    isOpportunityZone: true,
    listingCode: "CO-OFF-001",
  },
  {
    id: 2, // Changed from string to number
    title: "Retail Space in Liberty Plaza",
    price: 85000000,
    priceType: "fixed",
    type: "Retail",
    category: "sale",
    address: {
      street: "Liberty Plaza, R.A. De Mel Mawatha",
      city: "Colombo",
      state: "Western Province",
      zip: "00300",
    },
    details: {
      area: 1200,
      areaUnit: "SF",
      bedrooms: 0,
      bathrooms: 1,
      parkings: 2,
      yearBuilt: 1995,
      propertyType: "Retail",
      status: "Available",
      description:
        "Prime retail space in the heart of Colombo's shopping district. High foot traffic and excellent visibility make this an ideal location for retail businesses.",
      amenities: [ // Added amenities array
        "Display Windows",
        "Storage Area",
        "Central Location",
        "Public Transport Access",
      ],
    },
    features: [
      "Display Windows",
      "Storage Area",
      "Central Location",
      "Public Transport Access",
    ],
    images: [
      "https://images.unsplash.com/photo-1555529669-e69e7aa0ba9a",
      "https://images.unsplash.com/photo-1604014237800-1c9102c219da",
      "https://images.unsplash.com/photo-1441986300917-64674bd600d8",
    ],
    agent: {
      name: "Rohan De Silva",
      phone: "(+94) 77-987-6543",
      email: "rohan@commercialproperty.lk",
      company: "Commercial Property LK",
    },
    createdAt: "2023-02-10T10:15:00Z",
    isFeatured: false,
    listingCode: "CO-RET-002",
  },
  {
    id: 3, // Changed from string to number
    title: "Warehouse Complex in Peliyagoda",
    price: 175000000,
    priceType: "fixed",
    type: "Warehouse",
    category: "sale",
    address: {
      street: "Nuge Road, Peliyagoda",
      city: "Colombo",
      state: "Western Province",
      zip: "11600",
    },
    details: {
      area: 8500,
      areaUnit: "SF",
      bedrooms: 0,
      bathrooms: 3,
      parkings: 10,
      yearBuilt: 2010,
      propertyType: "Warehouse",
      status: "Available",
      description:
        "Spacious warehouse with loading docks, high ceilings, and ample parking. Located close to the port and major highways for efficient logistics operations.",
      amenities: [ // Added amenities array
        "Loading Docks",
        "24/7 Security",
        "CCTV Surveillance",
        "High Ceiling",
        "Office Space",
        "Truck Parking",
      ],
    },
    features: [
      "Loading Docks",
      "24/7 Security",
      "CCTV Surveillance",
      "High Ceiling",
      "Office Space",
      "Truck Parking",
    ],
    images: [
      "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d",
      "https://images.unsplash.com/photo-1504376379689-8d54347b26c6",
      "https://images.unsplash.com/photo-1553413077-190dd305871c",
    ],
    agent: {
      name: "Malik Fernando",
      phone: "(+94) 77-456-7890",
      email: "malik@commercialproperty.lk",
      company: "Commercial Property LK",
    },
    createdAt: "2023-03-05T09:45:00Z",
    isFeatured: true,
    listingCode: "CO-WH-003",
  },
  {
    id: 4, // Changed from string to number
    title: "Commercial Land in Katunayake EPZ",
    price: 320000000,
    priceType: "fixed",
    type: "Land",
    category: "sale",
    address: {
      street: "Export Processing Zone",
      city: "Katunayake",
      state: "Western Province",
      zip: "11450",
    },
    details: {
      area: 25000,
      areaUnit: "SF",
      bedrooms: 0,
      bathrooms: 0,
      parkings: 0,
      yearBuilt: 0,
      propertyType: "Land",
      status: "Available",
      description:
        "Prime commercial land within the Export Processing Zone. Ideal for manufacturing, warehousing, or logistics operations with tax incentives and infrastructure support.",
      amenities: [ // Added amenities array
        "Flat Terrain",
        "Road Access",
        "Electricity Connection",
        "Water Supply",
        "Tax Incentives",
        "Near Airport",
      ],
    },
    features: [
      "Flat Terrain",
      "Road Access",
      "Electricity Connection",
      "Water Supply",
      "Tax Incentives",
      "Near Airport",
    ],
    images: [
      "https://images.unsplash.com/photo-1500382017468-9049fed747ef",
      "https://images.unsplash.com/photo-1500076656116-558758c991c1",
      "https://images.unsplash.com/photo-1473163928189-364b2c4e1135",
    ],
    agent: {
      name: "Priyanka Jayawardena",
      phone: "(+94) 77-234-5678",
      email: "priyanka@commercialproperty.lk",
      company: "Commercial Property LK",
    },
    createdAt: "2023-04-20T11:30:00Z",
    isFeatured: false,
    listingCode: "CO-LAND-004",
  },
  {
    id: 5, // Changed from string to number
    title: "Restaurant Space in Negombo",
    price: 45000000,
    priceType: "fixed",
    type: "Restaurant",
    category: "sale",
    address: {
      street: "Lewis Place",
      city: "Negombo",
      state: "Western Province",
      zip: "11500",
    },
    details: {
      area: 1800,
      areaUnit: "SF",
      bedrooms: 0,
      bathrooms: 2,
      parkings: 6,
      yearBuilt: 2015,
      propertyType: "Restaurant",
      status: "Available",
      description:
        "Fully equipped restaurant space in the tourist hub of Negombo. Ready to operate with kitchen equipment, dining area, and outdoor seating with beach views.",
      amenities: [ // Added amenities array
        "Commercial Kitchen",
        "Bar Counter",
        "Outdoor Seating",
        "Beach View",
        "Tourist Area",
        "Parking Space",
      ],
    },
    features: [
      "Commercial Kitchen",
      "Bar Counter",
      "Outdoor Seating",
      "Beach View",
      "Tourist Area",
      "Parking Space",
    ],
    images: [
      "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4",
      "https://images.unsplash.com/photo-1555396273-367ea4eb4db5",
      "https://images.unsplash.com/photo-1414235077428-338989a2e8c0",
    ],
    agent: {
      name: "Anton Perera",
      phone: "(+94) 77-345-6789",
      email: "anton@commercialproperty.lk",
      company: "Commercial Property LK",
    },
    createdAt: "2023-05-15T14:20:00Z",
    isFeatured: true,
    listingCode: "CO-REST-005",
  },
  {
    id: 6, // Changed from string to number
    title: "Boutique Hotel in Galle Fort",
    price: 450000000,
    priceType: "fixed",
    type: "Hotel",
    category: "sale",
    address: {
      street: "Church Street, Fort",
      city: "Galle",
      state: "Southern Province",
      zip: "80000",
    },
    details: {
      area: 4500,
      areaUnit: "SF",
      bedrooms: 8,
      bathrooms: 10,
      parkings: 4,
      yearBuilt: 1750,
      propertyType: "Hotel",
      status: "Available",
      description:
        "Historic Dutch colonial building converted into a luxury boutique hotel. Features 8 en-suite rooms, restaurant, courtyard, and rooftop terrace with ocean views.",
      amenities: [ // Added amenities array
        "Colonial Architecture",
        "UNESCO World Heritage Site",
        "Ocean View",
        "Restaurant",
        "Courtyard Garden",
        "Rooftop Terrace",
      ],
    },
    features: [
      "Colonial Architecture",
      "UNESCO World Heritage Site",
      "Ocean View",
      "Restaurant",
      "Courtyard Garden",
      "Rooftop Terrace",
    ],
    images: [
      "https://images.unsplash.com/photo-1566073771259-6a8506099945",
      "https://images.unsplash.com/photo-1582719508461-905c673771fd",
      "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4",
    ],
    agent: {
      name: "Dilshan Mendis",
      phone: "(+94) 77-567-8901",
      email: "dilshan@commercialproperty.lk",
      company: "Commercial Property LK",
    },
    createdAt: "2023-06-10T16:45:00Z",
    isFeatured: true,
    listingCode: "SO-HOTEL-006",
  },
  {
    id: 7, // Changed from string to number
    title: "Co-Working Space in Bambalapitiya",
    price: 120000000,
    priceType: "fixed",
    type: "CoWorking",
    category: "sale",
    address: {
      street: "Galle Road, Bambalapitiya",
      city: "Colombo",
      state: "Western Province",
      zip: "00400",
    },
    details: {
      area: 3200,
      areaUnit: "SF",
      bedrooms: 0,
      bathrooms: 4,
      parkings: 8,
      yearBuilt: 2020,
      propertyType: "CoWorking",
      status: "Available",
      description:
        "Modern co-working space with flexible workstations, private offices, meeting rooms, and event space. Fully operational with existing membership base.",
      amenities: [ // Added amenities array
        "Fiber Internet",
        "Meeting Rooms",
        "Event Space",
        "Kitchen Area",
        "24/7 Access",
        "Phone Booths",
      ],
    },
    features: [
      "Fiber Internet",
      "Meeting Rooms",
      "Event Space",
      "Kitchen Area",
      "24/7 Access",
      "Phone Booths",
    ],
    images: [
      "https://images.unsplash.com/photo-1497366754035-f200968a6e72",
      "https://images.unsplash.com/photo-1497366811353-6870744d04b2",
      "https://images.unsplash.com/photo-1497215842964-222b430dc094",
    ],
    agent: {
      name: "Nadia Hussain",
      phone: "(+94) 77-678-9012",
      email: "nadia@commercialproperty.lk",
      company: "Commercial Property LK",
    },
    createdAt: "2023-07-05T13:15:00Z",
    isFeatured: false,
    listingCode: "CO-CW-007",
  },
  {
    id: 8, // Changed from string to number
    title: "Office Building in Rajagiriya",
    price: 380000000,
    priceType: "fixed",
    type: "Office",
    category: "sale",
    address: {
      street: "Sri Jayawardenepura Mawatha",
      city: "Rajagiriya",
      state: "Western Province",
      zip: "10100",
    },
    details: {
      area: 6800,
      areaUnit: "SF",
      bedrooms: 0,
      bathrooms: 6,
      parkings: 15,
      yearBuilt: 2016,
      propertyType: "Office",
      status: "Available",
      description:
        "Modern office building with 4 floors, elevator, backup power, and ample parking. Located in the administrative capital with easy access to government offices.",
      amenities: [ // Added amenities array
        "Elevator",
        "Backup Generator",
        "Central AC",
        "Server Room",
        "Conference Facilities",
        "Cafeteria",
      ],
    },
    features: [
      "Elevator",
      "Backup Generator",
      "Central AC",
      "Server Room",
      "Conference Facilities",
      "Cafeteria",
    ],
    images: [
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab",
      "https://images.unsplash.com/photo-1462826303086-329426d1aef5",
      "https://images.unsplash.com/photo-1497366754035-f200968a6e72",
    ],
    agent: {
      name: "Ravi Peiris",
      phone: "(+94) 77-789-0123",
      email: "ravi@commercialproperty.lk",
      company: "Commercial Property LK",
    },
    createdAt: "2023-08-20T10:30:00Z",
    isFeatured: true,
    listingCode: "CO-OFF-008",
  },
  {
    id: 9, // Changed from string to number
    title: "Shopping Complex in Kandy",
    price: 280000000,
    priceType: "fixed",
    type: "Retail",
    category: "sale",
    address: {
      street: "Peradeniya Road",
      city: "Kandy",
      state: "Central Province",
      zip: "20000",
    },
    details: {
      area: 7500,
      areaUnit: "SF",
      bedrooms: 0,
      bathrooms: 8,
      parkings: 25,
      yearBuilt: 2012,
      propertyType: "Retail",
      status: "Available",
      description:
        "Three-story shopping complex with 15 retail units, food court, and basement parking. Located on the main road with high visibility and foot traffic.",
      amenities: [ // Added amenities array
        "Multiple Retail Units",
        "Food Court",
        "Basement Parking",
        "Escalators",
        "Central Location",
        "Security System",
      ],
    },
    features: [
      "Multiple Retail Units",
      "Food Court",
      "Basement Parking",
      "Escalators",
      "Central Location",
      "Security System",
    ],
    images: [
      "https://images.unsplash.com/photo-1519567241046-7f570eee3ce6",
      "https://images.unsplash.com/photo-1567449303078-57ad995bd17a",
      "https://images.unsplash.com/photo-1604014237800-1c9102c219da",
    ],
    agent: {
      name: "Kumari Bandara",
      phone: "(+94) 77-890-1234",
      email: "kumari@commercialproperty.lk",
      company: "Commercial Property LK",
    },
    createdAt: "2023-09-15T12:00:00Z",
    isFeatured: false,
    listingCode: "CE-RET-009",
  },
  {
    id: 10, // Changed from string to number
    title: "Industrial Facility in Biyagama",
    price: 210000000,
    priceType: "fixed",
    type: "Warehouse",
    category: "sale",
    address: {
      street: "Biyagama Export Processing Zone",
      city: "Biyagama",
      state: "Western Province",
      zip: "11650",
    },
    details: {
      area: 12000,
      areaUnit: "SF",
      bedrooms: 0,
      bathrooms: 5,
      parkings: 20,
      yearBuilt: 2008,
      propertyType: "Warehouse",
      status: "Available",
      description:
        "Industrial facility with production area, warehouse space, offices, and staff facilities. Located in the EPZ with all infrastructure and export facilities.",
      amenities: [ // Added amenities array
        "Production Area",
        "Warehouse Space",
        "Office Area",
        "Staff Facilities",
        "Loading Bays",
        "3-Phase Power",
      ],
    },
    features: [
      "Production Area",
      "Warehouse Space",
      "Office Area",
      "Staff Facilities",
      "Loading Bays",
      "3-Phase Power",
    ],
    images: [
      "https://images.unsplash.com/photo-1553413077-190dd305871c",
      "https://images.unsplash.com/photo-1504376379689-8d54347b26c6",
      "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d",
    ],
    agent: {
      name: "Sunil Perera",
      phone: "(+94) 77-901-2345",
      email: "sunil@commercialproperty.lk",
      company: "Commercial Property LK",
    },
    createdAt: "2023-10-10T15:30:00Z",
    isFeatured: true,
    listingCode: "CO-WH-010",
  },
  {
    id: 11, // Changed from string to number
    title: "Development Land in Battaramulla",
    price: 180000000,
    priceType: "fixed",
    type: "Land",
    category: "sale",
    address: {
      street: "Pannipitiya Road",
      city: "Battaramulla",
      state: "Western Province",
      zip: "10120",
    },
    details: {
      area: 20000,
      areaUnit: "SF",
      bedrooms: 0,
      bathrooms: 0,
      parkings: 0,
      yearBuilt: 0,
      propertyType: "Land",
      status: "Available",
      description:
        "Prime development land in rapidly growing administrative area. Suitable for office complex, mixed-use development, or institutional use.",
      amenities: [ // Added amenities array
        "Flat Terrain",
        "Main Road Frontage",
        "Utilities Available",
        "Development Potential",
        "Near Government Offices",
      ],
    },
    features: [
      "Flat Terrain",
      "Main Road Frontage",
      "Utilities Available",
      "Development Potential",
      "Near Government Offices",
    ],
    images: [
      "https://images.unsplash.com/photo-1500382017468-9049fed747ef",
      "https://images.unsplash.com/photo-1500076656116-558758c991c1",
      "https://images.unsplash.com/photo-1473163928189-364b2c4e1135",
    ],
    agent: {
      name: "Lakshman Silva",
      phone: "(+94) 77-012-3456",
      email: "lakshman@commercialproperty.lk",
      company: "Commercial Property LK",
    },
    createdAt: "2023-11-05T09:00:00Z",
    isFeatured: false,
    listingCode: "CO-LAND-011",
  },
  {
    id: 12, // Changed from string to number
    title: "Beachfront Restaurant in Unawatuna",
    price: 75000000,
    priceType: "fixed",
    type: "Restaurant",
    category: "sale",
    address: {
      street: "Beach Road",
      city: "Unawatuna",
      state: "Southern Province",
      zip: "80600",
    },
    details: {
      area: 2200,
      areaUnit: "SF",
      bedrooms: 0,
      bathrooms: 3,
      parkings: 8,
      yearBuilt: 2017,
      propertyType: "Restaurant",
      status: "Available",
      description:
        "Successful beachfront restaurant with direct beach access. Includes dining area, bar, kitchen, storage, and staff quarters. Established business with loyal clientele.",
      amenities: [ // Added amenities array
        "Beachfront Location",
        "Fully Equipped Kitchen",
        "Bar Area",
        "Outdoor Seating",
        "Staff Quarters",
        "Tourist Hotspot",
      ],
    },
    features: [
      "Beachfront Location",
      "Fully Equipped Kitchen",
      "Bar Area",
      "Outdoor Seating",
      "Staff Quarters",
      "Tourist Hotspot",
    ],
    images: [
      "https://images.unsplash.com/photo-1514933651103-005eec06c04b",
      "https://images.unsplash.com/photo-1555396273-367ea4eb4db5",
      "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4",
    ],
    agent: {
      name: "Chaminda Fernando",
      phone: "(+94) 77-123-4567",
      email: "chaminda@commercialproperty.lk",
      company: "Commercial Property LK",
    },
    createdAt: "2023-12-15T11:45:00Z",
    isFeatured: true,
    listingCode: "SO-REST-012",
  },
];

export default mockProperties;
